/**
 * 설정 모드 사이드바 — 역할에 따라 노출 항목을 걸러낸다.
 * - 일반: 내 프로필만
 * - 마스터·관리: fullAccessOnly 포함
 * - masterOnly(메뉴 관리): ROLE_MASTER만
 */
import { isFullAccessRole, isMaster } from '@/shared/utils/authRoles';
import type { MenuLink, SidebarMenuItem } from './sidebarMenuConfig';

const isSettingsLinkVisible = (
  link: MenuLink,
  role?: string | null,
  roles?: string[] | null,
): boolean => {
  if (link.masterOnly) {
    return (
      isMaster(role) || (roles ?? []).some((r) => isMaster(r))
    );
  }
  if (!link.fullAccessOnly) return true;
  return isFullAccessRole(role);
};

export const filterSettingsSidebarByRole = (
  items: SidebarMenuItem[],
  role?: string | null,
  roles?: string[] | null,
): SidebarMenuItem[] => {
  return items.filter((item) => {
    if ('type' in item) return false;
    if ('children' in item) return false;
    return isSettingsLinkVisible(item, role, roles);
  });
};
